import { Label } from "@/shared/components/ui/label";
import { DateStringPicker } from "@/shared/components/date-picker";
import { InputErrorMessages } from "@/shared/components/errors/input-error-messages";
import { Input } from "@/shared/components/ui/input";

interface DateTimeInputProps {
  label: string;
  date: string | null;
  onDateChange: (date: string | null) => void;
  hint?: string;
  errors?: string[];
  disabled?: boolean;
}

/**
 * @deprecated Use {@link ../field/date-picker-field.tsx}
 */
export function DateTimeInput({
  label,
  date,
  onDateChange,
  hint,
  errors,
  disabled,
}: DateTimeInputProps) {
  return (
    <div className="grid content-start gap-1.5">
      <Label>{label}</Label>
      <div className="grid grid-cols-4 gap-2">
        <div className="col-span-3">
          <DateStringPicker
            date={date}
            onDateChange={(newDate) => {
              if (newDate == null) onDateChange(newDate);
              const newDateWithTime = new Date(newDate!);
              const time = toTime(date);
              const [hours, minutes] = time.split(":");
              newDateWithTime.setHours(Number(hours), Number(minutes));
              onDateChange(newDateWithTime.toISOString());
            }}
            markError={errors !== undefined && errors.length > 0}
            disabled={disabled}
          />
        </div>
        <Input
          type="time"
          id="time-picker"
          step="60"
          value={toTime(date)}
          onChange={(e) => {
            const [hours, minutes] = e.target.value.split(":");
            const newDate = date ? new Date(date) : new Date();
            newDate.setHours(Number(hours), Number(minutes));
            onDateChange(newDate.toISOString());
          }}
          className="bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
          disabled={disabled}
        />
      </div>
      <span className="text-muted-foreground text-sm" hidden={!hint}>
        {hint}
      </span>
      <InputErrorMessages errors={errors ?? []} />
    </div>
  );
}

function toTime(date: string | null): string {
  if (!date) return "09:00"; // Default time if no date is provided
  const d = new Date(date);
  return d.toTimeString().split(" ")[0].substring(0, 5); // Returns time in HH:MM
}
